import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import type {UnmanagedSummaryT} from '@freckle/school/ts/rostering/components/clean-up-roster/clean-up-phase'
import {FinishedMerging} from '@freckle/school/ts/rostering/components/common/finished-merging'
import {Success} from '@freckle/school/ts/rostering/components/common/success'

type Props = {
  unmanaged: UnmanagedSummaryT
}

export function NoCoursesFound({unmanaged}: Props) {
  const {t} = useSafeTranslation()
  return (
    <div>
      <FinishedMerging unmanaged={unmanaged} />
      <br />
      <Success muted title={t('NO_COURSES_FOUND_TITLE')} />
    </div>
  )
}
